/** The admin panel's active hub (a site id), persisted locally.
 *
 * The api client sends it as the X-PME-Hub header on every request; the
 * server treats it as an intersection with the caller's existing site
 * visibility, so it can only ever narrow what an admin sees.
 */

const KEY = "pme_active_hub";

export function getActiveHub(): number | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw && /^\d+$/.test(raw) ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function setActiveHub(siteId: number | null): void {
  try {
    if (siteId == null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(siteId));
  } catch {
    /* storage unavailable — switcher simply won't persist */
  }
}
